// ** UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ** Components
import Section from '@/components/common/Section';
import ComponentElementsImageGridCard from '@/components/strapi/Elements/ComponentElementsImageGridCard';

// ** Type
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksImageGridBlock as BlocksPartnerBlockProps } from '@/types/graphql';

type ComponentBlocksImageGridBlockProps = StrapiComponentProps<BlocksPartnerBlockProps>;

const ComponentBlocksImageGridBlock = ({
	host,
	imageGridContent,
	imageGridSectionTitle
}: ComponentBlocksImageGridBlockProps) => {
	return (
		<Section>
			{imageGridSectionTitle && (
				<Typography
					variant="title-lg"
					component="h2"
					sx={{
						mb: 10,
						color: 'common.black',
						fontSize: { xs: '2rem', md: '2.5rem' },
						lineHeight: { xs: '2.5rem', md: '3rem' },
						letterSpacing: { xs: '-0.64px', md: '-1.2px' }
					}}
				>
					{imageGridSectionTitle}
				</Typography>
			)}

			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: {
						xs: '1fr',
						sm: '1fr 1fr',
						md: 'repeat(3, 1fr)'
					},
					gap: 8,
					width: '100%'
				}}
			>
				{imageGridContent?.map((item) => {
					if (!item?.id) return null;
					return (
						<ComponentElementsImageGridCard
							key={item.id}
							image={item.image}
							host={host}
							pageRelation={item.pageRelation}
							imageGridCaption={item.imageGridCaption}
						/>
					);
				})}
			</Box>
		</Section>
	);
};

export default ComponentBlocksImageGridBlock;
